export function extractSearchTerms(fullSearchTerm: string) {
  const [, searchTerm = fullSearchTerm] = fullSearchTerm.match(/(.*?)\*/) ?? [];
  const [, tagSearchTerm = undefined] = fullSearchTerm.match(/\*(.*)/) ?? [];

  return {
    searchTerm,
    tagSearchTerm,
  };
}
